import styled from 'styled-components'

export const ErrorWrapper = styled.div`
    span {
		color: ${props => props.theme.mainRed} !important;
	}
`

export const Input = styled.input`
	width: 100%;
	height: 38px;
	outline: none;
	border: 1px solid
		${(props) =>
		(props.status === 'valid' && props.theme.mainGreen) ||
		(props.status === 'error' && props.theme.mainRed) ||
		"#19173B"};
	color: ${(props) => props.theme.secondaryColor};
	background-color: transparent;
	border-radius: 8px;
	&::placeholder {
		color: ${(props) => props.theme.secondaryColor};
	}
	font-size: 0.9rem;
	/* letter-spacing: 1.5px; */
	font-weight: 500;
	padding: 10px 12px;
	transition: border 0.5s ease-in-out;
	&:focus {
		border-color:${(props) =>
		(props.status === 'valid' && props.theme.mainGreen) ||
		(props.status === 'error' && props.theme.mainRed) ||
		"#9F64DF"};
	}

		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus {
		-webkit-box-shadow: 0 0 0 1000px transparent inset !important;
		box-shadow: 0 0 0 1000px transparent inset !important;
		-webkit-text-fill-color: ${(props) => props.theme.secondaryColor} !important;
		transition: background-color 9999s ease-out 0s !important;
	}


	@media screen and (max-width: 768px) {
		height: 42px;
	}

`

export const SubmitBtn = styled.button`
	width: 100%;
	height: 48px;
	border-radius: 8px;
	color: #2A2A2A !important;
	background: linear-gradient(to right, #FC6432, #A855F7);
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	font-weight: 500;
	cursor: ${(props) => (props.active && 'pointer') || 'not-allowed'};

	@media screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const Body = styled.div`
	position: relative;
	background-color: ${(props) => props.theme.secondaryBg};
	min-width: 500px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 8px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	transition: all 0.3s 0.3s;

	@media screen and (max-width: 768px) {
		min-width: 90%;
	}
`


export const Row = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: ${(props) => props.marginTop || '16px'};
	position: relative;
	transition: all 0.3s;
	@media screen and (max-width: 768px) {
		width: 100%;
	}
`

export const RulesContainer = styled.div`
	display: flex;
	gap: 4px;
	margin: 10px 0;
	align-items: center;
	color: ${(props) => props.theme.color};

	@media screen and (max-width: 768px) {
		width: 100%;
		font-size: 0.5rem;
	}
`

export const Rules = styled.span`
	color: ${(props) => props.theme.primaryOrange};
	font-size: ${(props) => props.fontSize || '0.9rem'};
	cursor: pointer;
	margin: 0 2px;
`

export const CheckBox = styled.div`
	min-width: 18px;
	min-height: 18px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	color: ${(props) => props.theme.secondaryColor};
	border: 1.5px solid ${(props) => props.theme.secondaryColor};
	background-color: transparent;

	&:hover{
	box-shadow: 0 0 2px 2px rgba(0,0,0,0.2);
	}

`

export const Label = styled.div`
	font-size: 0.9rem;
	color: ${(props) => "#E9EEFC"} !important;
	white-space: nowrap;
	margin-bottom: 0px;
	display: flex;
	align-items: center;
	gap: 4px;
`

export const TabChanger = styled.div`

	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.9rem;
	// color: ${(props) => props.theme.color};

	@media screen and (max-width: 480px) {
		font-size: 0.8rem;
	}
`